module.exports = __webpack_public_path__ + "img/rule.f0e87e6c.png";